import {useTranslation} from "react-i18next";
import {useEffect, useRef, useState} from "react";
import Form from "react-bootstrap/Form";
import Collapse from "react-bootstrap/Collapse";
import {Button, ButtonGroup, Dropdown} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import DataRange from "components/datetime/DataRange";
import moment from "moment";

const FormFiltersModel = {
    uuid: "",
    code: "",
    data: "",
    type: "",
    error: "",
    product: "",
};

const LogsFilters = ({filtersRef, params, onChangeDate}) => {
    const {t} = useTranslation("tables");
    const [filters, setFilters] = useState({...FormFiltersModel});
    const {t: _Tc} = useTranslation("choices");
    // Estados con valores por defecto
    const [dateRange, setDateRange] = useState();

    const defaultRange = useRef({
        start: moment().subtract(7, "days"),
        end: moment(),
        startString: "",
        endString: "",
    });

    useEffect(() => {
        defaultRange.current.startString = defaultRange.current.start.format("DD-MM-YYYY");
        defaultRange.current.endString = defaultRange.current.end.format("DD-MM-YYYY");
        setDateRange(`${defaultRange.current.startString} | ${defaultRange.current.endString}`);

        filtersRef.current.chosen.start_date = defaultRange.current.start.format("YYYY-MM-DD");
        filtersRef.current.chosen.end_date = defaultRange.current.end.format("YYYY-MM-DD");
        if (onChangeDate) {
            onChangeDate({
                start_date: filtersRef.current.chosen.start_date,
                end_date: filtersRef.current.chosen.end_date,
            });
        }
    }, []);

    // Manejo de cambios en los inputs
    const handleInputChange = (key, value) => {
        let filters_ = {...filters};
        filters_[key] = value.trim();
        setFilters(filters_);
        if (value) {
            filtersRef.current.chosen[key] = value;
        } else {
            delete filtersRef.current.chosen[key];
        }
    };

    // Aplicar dateRange, uuid y code
    const applyAllFilters = () => {
        filtersRef.current.filter();
    };

    // Función para limpiar los inputs además de aplicar la función onClearFilters
    const handleClearFilters = () => {
        // Resetear valores de los inputs
        setFilters({...FormFiltersModel});
        // Restablecemos el rango de fecha por defecto
        filtersRef.current.clear();
        clearDateRange();
    };

    const changeDateRange = (start, end) => {
        const momentStart = moment(start);
        const momentEnd = moment(end);
        setDateRange(`${momentStart.format("DD-MM-YYYY")} | ${momentEnd.format("DD-MM-YYYY")}`);
        filtersRef.current.chosen.start_date = momentStart.format("YYYY-MM-DD");
        filtersRef.current.chosen.end_date = momentEnd.format("YYYY-MM-DD");
        if (onChangeDate) {
            onChangeDate({
                start_date: filtersRef.current.chosen.start_date,
                end_date: filtersRef.current.chosen.end_date,
            });
        }
    };

    const clearDateRange = () => {
        // Restablecemos el rango de fecha por defecto
        setDateRange(`${defaultRange.current.startString} | ${defaultRange.current.endString}`);
        filtersRef.current.chosen.start_date = defaultRange.current.start.format("YYYY-MM-DD");
        filtersRef.current.chosen.end_date = defaultRange.current.end.format("YYYY-MM-DD");
        if (onChangeDate) {
            onChangeDate({
                start_date: filtersRef.current.chosen.start_date,
                end_date: filtersRef.current.chosen.end_date,
            });
        }
    };

    return (
        <Collapse in={true}>
            <div id="filter-collapse">
                <div className="row">
                    {/* Botón para limpiar filtros */}
                    <Button variant="link" type="button" onClick={handleClearFilters} style={{color: "black"}} className="col-1">
                        <FontAwesomeIcon icon="filter-circle-xmark" />
                    </Button>
                    {/* class="col mb-3 ms-auto"style="max-width: 165px;" */}
                    <div className="col mb-3" style={{maxWidth: "165px"}}>
                        <label style={{width: "100%", fontWeight: "bold", textAlign: "center"}}>{t("UUID")}</label>
                        <input
                            type="text"
                            className="form-control"
                            value={filters.uuid}
                            onChange={(e) => handleInputChange("uuid", e.target.value)}
                        />
                    </div>
                    <div className="col-1">
                        <label style={{width: "100%", fontWeight: "bold", textAlign: "center"}}>{t("Data")}</label>
                        <input
                            type="text"
                            className="form-control"
                            value={filters.data}
                            onChange={(e) => handleInputChange("data", e.target.value)}
                        />
                    </div>
                    <div className="col-1">
                        <label style={{width: "100%", fontWeight: "bold", textAlign: "center"}}>{t("Codigo")}</label>
                        <input
                            type="text"
                            className="form-control"
                            value={filters.code}
                            onChange={(e) => handleInputChange("code", e.target.value)}
                        />
                    </div>
                    <div className="col-1">
                        <label style={{width: "100%", fontWeight: "bold", textAlign: "center"}}>{t("Tipo")}</label>
                        <Form.Select value={filters.type} onChange={(e) => handleInputChange("type", e.target.value)}>
                            <option value="">{_Tc("messages_log.a")}</option>
                            <option value="u">{_Tc("messages_log.u")}</option>
                            <option value="d">{_Tc("messages_log.d")}</option>
                        </Form.Select>
                    </div>
                    <div className="col-1">
                        <label style={{width: "100%", fontWeight: "bold", textAlign: "center"}}>{t("Error")}</label>
                        <input
                            type="text"
                            className="form-control"
                            value={filters.error}
                            onChange={(e) => handleInputChange("error", e.target.value)}
                        />
                    </div>

                    <div className="col-1">
                        <label style={{width: "100%", fontWeight: "bold", textAlign: "center"}}>{t("Producto")}</label>
                        {params && params.products.length ? (
                            <Form.Select value={filters.product} onChange={(e) => handleInputChange("product", e.target.value)}>
                                <option value="">{_Tc("messages_log.a")}</option>
                                {params.products.map((option, idx) => (
                                    <option key={idx} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </Form.Select>
                        ) : params && params.products.length === 1 ? (
                            <div className="form-control bg-light">{params.products[0].label}</div>
                        ) : (
                            <div className="form-control text-muted" style={{fontStyle: "italic"}}>
                                Ninguno
                            </div>
                        )}
                    </div>

                    <div className="col-2">
                        <label style={{width: "100%", fontWeight: "bold", textAlign: "center"}}>
                            {t("notifications.date_range")}
                        </label>
                        <ButtonGroup className="w-100">
                            <Dropdown className="w-100">
                                <Dropdown.Toggle
                                    variant="Secondary"
                                    id="dropdown-basic"
                                    style={{border: "1px solid #ced4da", minWidth: "100%"}}
                                    className="custom-dropdown-toggle">
                                    <FontAwesomeIcon icon="fa-solid fa-calendar-day" />
                                    <label style={{width: "90%", textAlign: "center"}}> {dateRange}</label>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <DataRange rangeData={changeDateRange} maxSpan={30} maxDate={new Date()} />
                                </Dropdown.Menu>
                            </Dropdown>
                        </ButtonGroup>
                    </div>

                    <div className="col-1">
                        <label style={{width: "100%", fontWeight: "bold", textAlign: "center"}}>&nbsp;</label>
                        <Button
                            variant="link"
                            type="button"
                            onClick={clearDateRange}
                            style={{color: "black"}}
                            // className="w-100 mt-1"
                            className="btn-outline-secondary "
                            title="Limpiar fechas">
                            <FontAwesomeIcon icon="xmark" />
                        </Button>
                    </div>

                    <div className="col-1">
                        <label style={{width: "100%", fontWeight: "bold", textAlign: "center"}}>&nbsp;</label>
                        <Button
                            variant="link"
                            type="button"
                            onClick={applyAllFilters}
                            style={{color: ""}}
                            className="btn-outline-primary "
                            title="Aplicar">
                            <FontAwesomeIcon icon="magnifying-glass" />
                        </Button>
                    </div>
                </div>
            </div>
        </Collapse>
    );
};

export default LogsFilters;
